import moment from "moment";
import getBoxSize from '../utils/box_algo';

const getters = {
    categories(state){
        if(state.categories === null || state.gifts === null) return null;
        const existingCategory = state.categories.map(category => {
            return {
                name: category.product_type,
                img: category.image.src,
            };
        })

        return existingCategory;
    },
    filteredGifts(state){
        if(state.gifts === null) return null;
        if(!state.currentCategory) return Object.values(state.gifts).flat();
        return state.gifts[state.currentCategory];
    },
    checkedAddons(state){
        const addons = state.box.filter((item) => item.boxContentType == "boxAddons");
        if(!addons.length || state.deliveryArea !== 'nationwide') 
            return addons;
        const filteredAddons = addons.slice();
        filteredAddons.forEach(addon => {
            if(addon.tags.includes('flowers'))
                addon.isValid = false;
        })
        return filteredAddons;
    },
    boxPrice(state){
        const price = state.box.reduce((prevItem, item) => {
            return prevItem + (Number(item.variantPrice) * Number(item.amount));
        }, 0) * state.productAmount + state.delivery.delivery_fee;
        return price.toFixed(2);
    },
    boxSize(state){
        const sizes = {
            xs: 0,
            s: 0,
            m: 0,
            l: 0,
            xl: 0
        }
        state.box.forEach(item => {
            if(item.boxContentType == 'boxAddons' || item.boxContentType == 'card') return;
            sizes[item.product_size] += item.amount;
        })

        const boxSize = getBoxSize('malaysia',...Object.values(sizes))

        return boxSize;
    },
    availableDates(){
        const now = moment();
        const endTime = moment('5:00pm', 'h:mma');

        if(!now.isBefore(endTime)){
            return moment().add(1,'days').toDate();
        }

        return moment().toDate();
    },
    stepName(state){
        if(state.step === 1 && state.substep === 1){
            return {next:'Categories'}
        }
        else if(state.step === 1 && state.substep === 2){
            return {prev:'Gift Box', next:'Add Gifts'}
        }
        else if(state.step === 1 && state.substep === 3){
            return {prev:'Categories', next:'Add-ons'}
        }
        else if(state.step === 2){
            return {prev:'Add Gifts', next:'Cards'}
        }
        else if (state.step === 3){
            return {prev:'Add-ons', next:'Recipient'}
        }
        else if (state.step === 4){
            return {prev:'Cards', next:'Summary'}
        }
    }
}

export default getters;